// Safe env access. Vite exposes import.meta.env.VITE_*.
const env = import.meta.env as Record<string, string | undefined>;

export const ENV = {
  VSL_URL: env.VITE_VSL_URL ?? env.VITE_VSL_VIDEO_URL ?? "",
  WEBHOOK_APPLY: env.VITE_WEBHOOK_APPLY ?? "",
  CAL_URL: env.VITE_CAL_URL ?? env.VITE_BOOKING_URL ?? "",
  CHATBOT_WIDGET_URL: env.VITE_CHATBOT_WIDGET_URL ?? "",
  STORY_IMG_1: env.VITE_STORY_IMG_1 ?? "",
  STORY_IMG_2: env.VITE_STORY_IMG_2 ?? "",
  STORY_IMG_3: env.VITE_STORY_IMG_3 ?? "",
  // legacy (kept so old pages don't break)
  BOOKING_URL: env.VITE_BOOKING_URL ?? "",
  WEBHOOK_FORM_SUBMIT: env.VITE_WEBHOOK_FORM_SUBMIT ?? "",
  WEBHOOK_BOOKING_CONFIRMED: env.VITE_WEBHOOK_BOOKING_CONFIRMED ?? "",
  PIXEL_ID: env.VITE_PIXEL_ID ?? "",
  GA_ID: env.VITE_GA_ID ?? "",
  TYPEFORM_ID: env.VITE_TYPEFORM_ID ?? "",
  DEV: env.MODE === "development",
};

export const isMissing = (v: string | undefined) => !v || v.trim() === "";
